import {
  SAVE_TWA_AI_UI_EVENTS,
  UPDATE_TWA_AI_UI_EVENT,
  LOGOUT,
} from "../Actions/types";

const INITIAL_STATE = {
  events: [],
  loaded: false,
};

const twaAIReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SAVE_TWA_AI_UI_EVENTS:
      return {
        ...state,
        events: action.payload,
        loaded: true,
      };

    case UPDATE_TWA_AI_UI_EVENT:
      return {
        ...state,
        events: state.events.filter(
          event => event.event_type !== action.payload
        ),
      };

    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default twaAIReducer;
